import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { JSX, ReactNode } from "react";

interface DraggableProps {
	children: ReactNode;
	dragId: string;
	isDraggable: boolean;
}

function Draggable({
	children,
	dragId,
	isDraggable,
}: DraggableProps): JSX.Element {
	const { attributes, listeners, setNodeRef, transform, transition } =
		useSortable({ id: dragId });

	if (!isDraggable) {
		return <div>{children}</div>;
	}
	return (
		<div
			ref={setNodeRef}
			style={{
				transform: CSS.Transform.toString(transform),
				transition: transition || undefined,
			}}
			{...attributes}
			{...listeners}
		>
			{children}
		</div>
	);
}

export default Draggable;
